// shared constants for the lobby

export const TOAST_MS = {
  FAST: 1200,
  NORMAL: 1500,
};

export const POSTER = {
  // sizes (width in px, aspect-ratio is always 2:3)
  WIDTH_SM: 56,
  WIDTH_MD: 88,
  WIDTH_LG: 160,
  // initials font size per size variant
  INITIALS_SM: 18,
  INITIALS_MD: 28,
  INITIALS_LG: 56,
  INITIALS_HERO: 80,
  // hash math for deterministic palette/index
  HASH_PRIME: 31,
  CORNER_INDEX_MOD: 99,
};

export const FILE_SIZE = {
  // max bytes for an uploaded poster image (1.5MB)
  MAX_POSTER_BYTES: 1.5 * 1024 * 1024,
};
